import fire from '@store/firebase';
import { IupdateHashtag } from '@typings/common/hashtag.interface';
import { removeAtIndex } from '@utils/removeIndex';
const firestore = fire.firestore();

// 레거시?
export async function decreaseHashtagCount({
  hashtagId,
  collectionPath,
}: IupdateHashtag) {
  const hashtagPath = `${collectionPath}Hashtag`;
  const hashtagRef = firestore.collection(hashtagPath);

  // 카운터 줄이기
  const hashData = await hashtagRef
    .doc(hashtagId)
    .get()
    .then((res) => res.data());

  if (hashData) {
    if (hashData.docIdList.length === 1) {
      // 해시태그 완전 삭제 - 이거 보류
      // await hashtagRef.doc(hashtagId).delete();
    } else {
      hashtagRef
        .doc(hashtagId)
        .set({ count: hashData.count - 1 }, { merge: true });
    }
  }
}

export async function deleteHashDocIdList({
  hashtagId,
  collectionPath,
  docId,
}) {
  const hashtagPath = `${collectionPath}Hashtag`;
  const hashtagRef = firestore.collection(hashtagPath);
  const hashData = await hashtagRef
    .doc(hashtagId)
    .get()
    .then((res) => res.data());

  if (hashData) {
    const prevHashIdList = hashData!.docIdList;
    const findIndex = prevHashIdList.findIndex((id) => id === docId);
    const newIdList = prevHashIdList.slice();
    newIdList.splice(findIndex, 1);

    // 해시태그가 0개 되면 완전 삭제
    // 이거 보류
    // if (hashData.docIdList.length === 1) {
    //   return await hashtagRef.doc(hashtagId).delete();
    // } else {
    // }

    return await hashtagRef
      .doc(hashtagId)
      .set({ docIdList: newIdList }, { merge: true });
  }
}

export async function deleteHashtag({
  hashtagId,
  hashtagValue,
  collectionPath,
  docId,
}: IupdateHashtag) {
  const hashtagPath = `${collectionPath}Hashtag`;
  const hashtagRef = firestore.collection(hashtagPath);
  const collectionRef = firestore.collection(collectionPath);

  // 해당 해시태그에 있는 docIdList를 추출.
  const docIdList = await hashtagRef
    .doc(hashtagId)
    .get()
    .then((res) => {
      if (res.exists) {
        return res.data()!.docIdList;
      }
    });

  // 각 document를 순회하며 hashtagIdList에서 Id를 추출
  if (docIdList) {
    await Promise.all(
      docIdList.map((id) => {
        deleteHashtagInDoc({
          collectionPath,
          docId: id,
          hashId: hashtagId,
        });
      }),
    );
  }

  return hashtagRef.doc(hashtagId).delete();
}

export async function deleteHashtagInDoc({ collectionPath, docId, hashId }) {
  const ref = firestore.collection(`${collectionPath}`);
  // 해당 게시글의 기존 idList를 가져와서, 삭제할 Id를 제거하고 다시 추가한다.
  const prevIdList = await ref
    .doc(docId)
    .get()
    .then((res) => {
      if (res.exists) {
        return res.data()!.hashtagIdList;
      }
    });
  const result = removeAtIndex(prevIdList, hashId);

  return ref.doc(docId).set({ hashtagIdList: result }, { merge: true });
}
